
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { Toolbar } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom/cjs/react-router-dom';

function ConsentBanner(props) {
	const closeToolbar = () => {
		sessionStorage.setItem('hide-consent-banner', 'true')
		props.closeNotificationToolbar()
	}

	return (
		<Toolbar variant="dense" className="min-h-16 md:min-h-32 px-8 sm:px-12 py-0 flex items-center overflow-x-auto justify-between bg-black">
			<div>
				<span className='text-12 text-grey-500'>
					We collect certain data to enhance your experience and analyze how our services are used. This helps us improve functionality and provide better insights. By continuing to use our site, you consent to this data collection. For more details, please read our&nbsp;
				</span>
				<span>
					<Link to='/privacy-policy' >Privacy Policy</Link>
				</span>
			</div>
			<Button onClick={closeToolbar} >Accept</Button>
		</Toolbar>
	);
}

export default ConsentBanner;
